import normalizeComponent from '../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';
import script from './Tree.vue_rollup-plugin-vue=script.js';

/* script */
const __vue_script__ = script;
/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "ul",
    { ref: "tree", on: { mouseleave: _vm.onMouseOut } },
    _vm._l(_vm.nodes, function(node) {
      return _c("Node", {
        key: node.id,
        attrs: {
          selected: _vm.selected,
          node: node,
          level: 1,
          expanded: _vm.expanded,
          "expand-level": _vm.expandLevel,
          search: _vm.search,
          hovered: _vm.hovered
        },
        on: {
          "toggle-expand": _vm.onToggleExpand,
          input: _vm.onSelect,
          expand: _vm.onExpand,
          highlight: _vm.highlight
        },
        scopedSlots: _vm._u(
          [
            {
              key: "label",
              fn: function(ref) {
                var node = ref.node;
                return [_vm._t("label", null, { node: node })]
              }
            }
          ],
          null,
          true
        )
      })
    }),
    1
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = "data-v-6d7fd1d8";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/Tree/Tree.vue.js